export default __webpack_public_path__ + "static/media/Skull Gate Sabatons.ca1cd498.jpg";